<template>
  <div>
    <el-row class="title-bar" type="flex" justify="space-between">
      <div class="vertical-center-box">
        <div class="title-h3">모델 OID 목록</div>
        <div class="mr-l8">
          등록된 장비와 매칭되는 OID정보가 있을 경우 리스트로 표현합니다.
        </div>
      </div>
      <div>
        <w-header-search-button @click="showSearchTool = !showSearchTool"></w-header-search-button>
      </div>
    </el-row>
    <el-table-wrapper slot="body" v-loading="isLoading" ref="modelOidTable" :data="dataList" :columns="modelDicColumns" row-class-name="c-dblclick"
    :column-default="columnDefault" @condition-change="onTableConditionChange" :total="total" remote pagination
    :show-custom-header="true" :show-search-tool="showSearchTool" @row-dblclick="onDblClickRow" style="width:100%;">
      <template slot-scope="scope" slot="list-slot">
        <i class="el-icon-search" style="cursor:pointer" @click="openDeivceListPopup(scope.row)"/>
      </template>
    </el-table-wrapper>
    <w-set-model-oid-popup ref="setModelOidPopup" @reload-data="loadData" />
    <w-device-list-popup ref="deviceListPopup" />
  </div>
</template>

<script>
import msgUtil from '@/utils/message';
import { columnDefault } from '@/constants/table';
import cloneDeep from 'lodash/cloneDeep';
import NetdeviceSettingAPI from '@/api/settings/netdevice/netdevice-settings';
import WSetModelOidPopup from '@/views/settings/netdevice/OidSettings/VendorModelOidSettings/component/ModelOidSettingView/popup/SetModelOidPopup';
import WDeviceListPopup from '@/views/settings/netdevice/OidSettings/VendorModelOidSettings/component/ModelOidSettingView/popup/DeviceListPopup';
import { getValueAfterCheckEmpty } from '@/utils/string';

export default {
  name: 'WModelOidSettingView',
  components: {
    WSetModelOidPopup,
    WDeviceListPopup,
  },
  props: {
    activeTab: String,
  },
  data() {
    return {
      isLoading: false,
      columnDefault,
      total: null,
      dataList: null,
      showSearchTool: false,
      modelDicColumns: [
        {
          prop: 'objOid',
          label: '모델 OID',
          remoteProp: 'o.obj_oid',
          width: 800,
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'objtypeName',
          label: '장비 종류',
          remoteProp: 'ot.objtype_name',
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'objProductId',
          label: '모델 명',
          remoteProp: 'op.obj_product_id',
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'objCompanyName',
          label: '벤더사 명',
          remoteProp: 'oc.obj_company_name',
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'objCount',
          label: '장비 개수',
          sortable: true,
          width: 100,
        },
        {
          label: '장비 리스트',
          align: 'center',
          width: 100,
          scopedSlot: 'list-slot',
        },
      ],
    };
  },
  watch: {
    activeTab: {
      handler() {
        if (this.activeTab === this.$options.name) {
          this.loadData();
        }
      },
      immediate: true,
    },
  },
  methods: {
    loadData() {
      this.$nextTick(() => {
        this.isLoading = true;
        const tableParams = this.$refs.modelOidTable.getParameter();
        const params = {
          ...tableParams,
        };
        NetdeviceSettingAPI.getModelOidSettingList(params).then((result) => {
          if (result.data.success) {
            this.dataList = result.data.data;
            this.total = result.data.total;
          } else {
            this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '모델 OID 목록', result.data.success));
          }
        }).catch(() => {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '모델 OID 목록', false));
        }).finally(() => {
          this.isLoading = false;
        });
      });
    },
    getTableValueAfterCheckEmpty(row, column, value) {
      return getValueAfterCheckEmpty(value);
    },
    onDblClickRow(row) {
      this.$refs.setModelOidPopup.open(cloneDeep(row));
    },
    onTableConditionChange() {
      this.loadData();
    },
    openDeivceListPopup(row) {
      this.$refs.deviceListPopup.open(cloneDeep(row));
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/settings/netdevice/OidSettings/VendorModelOidSettings/component/ModelOidSettingView/index.vue